import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchBaseCategories, fetchLocaleTags } from 'spa/api/categories'

export const fetchCategories = createAsyncThunk(
  'categories/fetchBaseCategories',
  async () => {
    const response = await fetchBaseCategories()
    if (!response) {
      throw new Error('No response received from the server')
    }
    return response
  }
)

export const fetchLocaleTagsThunk = createAsyncThunk(
  'categories/fetchLocaleTags',
  async () => {
    const response = await fetchLocaleTags()
    if (!response) {
      throw new Error('No response received from the server')
    }
    return response
  }
)

const categoriesSlice = createSlice({
  name: 'categories',
  initialState: {
    categories: [],
    localeTags: {},
    loading: {
      categories: true,
      localeTags: true,
    },
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCategories.pending, state => {
        state.loading.categories = true
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.categories = action.payload
        state.loading.categories = false
        state.error = null
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading.categories = false
        state.error = action.error.message
      })
      .addCase(fetchLocaleTagsThunk.pending, state => {
        state.loading.localeTags = true
      })
      .addCase(fetchLocaleTagsThunk.fulfilled, (state, action) => {
        state.localeTags = action.payload
        state.loading.localeTags = false
        state.error = null
      })
      .addCase(fetchLocaleTagsThunk.rejected, (state, action) => {
        state.loading.localeTags = false
        state.error = action.error.message
      })
  },
})

export default categoriesSlice.reducer
